import {
  Box,
  ChakraStyleProps,
  Stack,
  StackProps,
  TextProps,
  useMediaQuery,
  Text,
  BoxProps,
} from "@chakra-ui/react";
import { useNavigate } from "@reach/router";
import { AnimateSharedLayout, motion } from "framer-motion";
import React, { forwardRef, useState, FC, useEffect } from "react";
import { ReactComponent as CloseIcon } from "../../assets/close.svg";

// TODO: This is not DRY!!
const ButtonStyling: {
  root: Partial<
    ChakraStyleProps &
      Pick<StackProps, "direction" | "spacing" | "align" | "justify">
  >;
  text: Partial<TextProps>;
} = {
  root: {
    backgroundColor: "#D95D5D",
    borderRadius: "50px",
    boxShadow: "0px 5px 32px -7px rgba(126, 136, 151, 0.8)",
    direction: "row",
    padding: "12px 24px",
    position: "relative",
    cursor: "pointer",
    spacing: "4",
    align: "center",
    justify: "flex-start",
  },
  text: {
    color: "#fff",
    flexGrow: 1,
  },
};

const MotionStack = motion(Stack);
export const ReferralFloater = forwardRef<HTMLDivElement>((props, ref) => {
  const navigate = useNavigate();
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  const [text, setText] = useState("Gana €");
  const handleClick = () => {
    navigate("/referrals");
  };
  return (
    <AnimateSharedLayout>
      <MotionStack
        id="subscribePlatformPopoverTrigger"
        ref={ref}
        {...ButtonStyling.root}
        onClick={handleClick}
        onMouseEnter={() => setText("Invita amigos y gana 50 €")}
        onMouseLeave={() => setText("Gana €")}
        layout
        transition={{ duration: 0.25, type: "spring" }}
      >
        <Box width="10px !important">🎁</Box>
        <Text
          {...ButtonStyling.text}
          textStyle={isLargerThan900 ? "button" : "buttonMobile"}
        >
          {text}
        </Text>
      </MotionStack>
    </AnimateSharedLayout>
  );
});

export const ReferralIcon: FC = (props) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/referrals");
  };
  return (
    <Stack
      spacing="2"
      onClick={handleClick}
      direction="row"
      align="center"
      style={{ cursor: "pointer" }}
    >
      <Stack
        align="center"
        justify="center"
        background="#FFD20A"
        borderRadius="50%"
        width="26px"
        height="26px"
      >
        <Text>💸</Text>
      </Stack>
      <Text textStyle="bodySmall">Gana</Text>
    </Stack>
  );
};

export const WelcomeStrip: FC<BoxProps> = (props) => {
  const STORAGE_KEY = "REFERRAL_STRIP_DISMISSED";
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const handleClick = () => {
    handleClose();
    navigate("/referrals");
  };

  useEffect(() => {
    try {
      const dismissedValue = localStorage.getItem(STORAGE_KEY);
      if ([null, "false"].includes(dismissedValue)) {
        setVisible(true);
      } else if (dismissedValue === "true") {
        setVisible(false);
      }
    } catch (e) {
      console.error(`Error in using local storage: ${e}`);
    }
  }, []);

  const handleClose = (e?: any) => {
    e?.stopPropagation();
    try {
      setVisible(false);
      localStorage.setItem(STORAGE_KEY, "true");
    } catch (e) {
      console.error(`Error in using local storage: ${e}`);
    }
  };

  if (!visible) {
    return null;
  }

  return (
    <Box
      position="relative"
      background="linear-gradient(180deg, #0078FF 0%, #00ACFF 100%)"
      boxShadow="0px 6px 15px rgba(176, 184, 198, 0.62)"
      height="45px"
      justify="center"
      align="center"
      {...props}
      cursor="pointer"
      onClick={handleClick}
    >
      <Box
        position="absolute"
        top="8px"
        right="8px"
        onClick={handleClose}
        css={{
          path: {
            fill: "#fff !important",
          },
        }}
      >
        <CloseIcon path="white" width="10px" />
      </Box>
      <Text
        lineHeight="45px"
        textStyle="buttonMobile"
        textAlign="center"
        color="white"
      >
        Invita amigos y gana hasta 50€
      </Text>
    </Box>
  );
};
